<template>
  <div class="QzList">
    <div
      v-if="isMoreCheck"
      class="QzList-list-moreCheck"
      @click="moreCheckEvent"
    >
      批量审核
    </div>
    <div v-else class="QzList-list-moreCheck"></div>
    <NOdata v-if="this.listData.length == 0" title="暂无数据"></NOdata>
    <van-checkbox-group
      v-else
      ref="checkboxGroup"
      class="QzList-list"
      v-model="checkArr"
    >
      <div
        v-for="(item, index) in listData"
        :key="'i' + index"
        @click="goDetail(item, index)"
      >
        <van-checkbox
          ref="checkbox"
          v-if="moreCheck"
          class="QzList-list-check"
          checked-color="#7469f8"
          :name="item"
        ></van-checkbox>
        <slot name="top" :item="item">
          <h2>
            {{ item[titleProp] }}
          </h2>
        </slot>
        <div
          class="QzList-list-status"
          v-if="statusProp"
          :style="returnColor(item[statusProp])"
        >
          <slot name="status" :item="item">
            {{ returnTkText(item[statusProp]) }}
          </slot>
        </div>
        <div v-if="tagProps.length > 0" class="QzList-list-tag">
          <slot name="tag" :item="item">
            <span v-for="(oitem, oindex) in tagProps" :key="oindex">
              {{ item[oitem] }}
            </span>
          </slot>
        </div>
        <slot v-if="listProps.length > 0" name="content" :item="item">
          <ul class="QzList-list-content">
            <li
              :style="oitem.type == 'col' ? 'width:50%' : 'width:100%'"
              v-for="(oitem, oindex) in listProps"
              :key="'o' + oindex"
            >
              <p>{{ oitem.label }}</p>
              ：{{ item[oitem.prop] }}
            </li>
          </ul>
        </slot>
        <slot name="bottom" :item="item"> </slot>
      </div>
    </van-checkbox-group>
    <qz-split></qz-split>
    <div v-if="moreCheck" class="QzList-button">
      <template v-for="(item, index) in buttonProps">
        <van-button
          v-if="item.cancel"
          :key="index"
          type="default"
          round
          @click="cancel"
        >
          {{ item.label }}
        </van-button>
        <van-button
          v-else
          :key="index"
          type="primary"
          round
          @click="submit(item)"
        >
          {{ item.label }}
        </van-button>
      </template>
    </div>
  </div>
</template>
<script>
import { returnTkText, returnColor } from "@/utils/exChang";
export default {
  name: "QzList",
  props: {
    searchValue: {
      type: String,
      default: ""
    },
    isMoreCheck: {
      type: Boolean,
      default: false
    },
    titleProp: {
      type: String,
      default: ""
    },
    statusProp: {
      type: String,
      default: ""
    },
    tagProps: {
      type: Array,
      default: () => []
    },
    listData: {
      type: Array,
      required: true,
      default: () => []
    },
    listProps: {
      type: Array,
      default: () => []
    },
    buttonProps: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      moreCheck: false,
      checkArr: []
    };
  },
  methods: {
    returnTkText(val) {
      return returnTkText(val);
    },
    returnColor(val) {
      return returnColor(val);
    },
    moreCheckEvent() {
      this.moreCheck = true;
      this.checkArr = [];
    },
    cancel() {
      this.moreCheck = false;
      this.$refs.checkboxGroup.toggleAll(false);
    },
    submit(item) {
      return item.func(this.checkArr);
    },
    goDetail(item, index) {
      if (this.moreCheck) {
        this.$refs.checkbox[index].toggle();
      } else {
        this.$emit("goDetail", item);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.QzList {
  .QzList-list-moreCheck {
    padding: 7px 15px;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #7469f8;
    font-weight: 400;
  }
  .QzList-list {
    padding: 0 15px;
    & > div {
      position: relative;
      background: #f2f2f4;
      border-radius: 8px;
      padding: 14px 15px;
      & + div {
        margin-top: 10px;
      }
      .QzList-list-check {
        position: absolute;
        top: 0;
        right: 0;
        transform: translate(30%, -30%);
        background-color: #fff;
        border-radius: 50%;
      }
      h2 {
        font-family: PingFangSC-Semibold;
        font-size: 16px;
        color: #333333;
        letter-spacing: 0;
        font-weight: 600;
        margin-bottom: 5px;
      }
      .QzList-list-status {
        position: absolute;
        top: 15px;
        right: 15px;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #ffa400;
        letter-spacing: 0;
        text-align: right;
        font-weight: 400;
      }
      .QzList-list-tag {
        margin-bottom: 2px;
        span {
          position: relative;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #999999;
          letter-spacing: 0;
          font-weight: 400;
          line-height: 20px;
          & + span {
            margin-left: 16px;
            &::before {
              content: "";
              height: 13px;
              position: absolute;
              border-left: 1px solid #e6e6e6;
              top: 3px;
              left: -9px;
            }
          }
        }
      }
      .QzList-list-content {
        display: flex;
        flex-wrap: wrap;
        li {
          display: flex;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #999999;
          letter-spacing: 0;
          font-weight: 400;
          margin-top: 2px;
          line-height: 20px;
          p {
            white-space: nowrap;
          }
        }
      }
    }
  }
  .QzList-button {
    position: fixed;
    bottom: 0;
    left: 0;
    width: calc(~"100% - 30px");
    display: flex;
    background-color: #fff;
    padding: 10px 15px;
    z-index: 999;
    &::before {
      position: absolute;
      box-sizing: border-box;
      content: " ";
      pointer-events: none;
      right: 0;
      top: 0;
      left: 16px;
      border-top: 1px solid #e5e5e5;
      -webkit-transform: scaleY(0.5);
      transform: scaleY(0.5);
    }
    .van-button {
      flex: 1;
      height: 50px;
      border: none;
      & + .van-button {
        margin-left: 15px;
        background: #7469f8;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/QzList/index.vue